var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{
          'text-red': this.value < 0,
          'text-green': this.value > 0,
      }},[_vm._v(_vm._s(this.formated))])
}
var staticRenderFns = []

export { render, staticRenderFns }